import { __rest } from "tslib";
import React from "react";
import { render } from "@testing-library/react";
import { createStore } from "redux";
import { Provider } from "react-redux";
export const renderWithRedux = (ui, _a) => {
    var { initialState, reducer } = _a, options = __rest(_a, ["initialState", "reducer"]);
    const store = createStore(reducer, initialState);
    const Wrapper = ({ children }) => (React.createElement(Provider, { store: store }, children));
    return render(ui, Object.assign({ wrapper: Wrapper }, options));
};
export const renderWithContext = (ui, _a) => {
    var { context, value } = _a, options = __rest(_a, ["context", "value"]);
    const Wrapper = ({ children }) => (React.createElement(context.Provider, { value: value }, children));
    return render(ui, Object.assign({ wrapper: Wrapper }, options));
};
export const renderWithContextOverRedux = (ui, _a) => {
    var { context, value, initialState, reducer } = _a, options = __rest(_a, ["context", "value", "initialState", "reducer"]);
    const store = createStore(reducer, initialState);
    const Wrapper = ({ children }) => (React.createElement(context.Provider, { value: value },
        React.createElement(Provider, { store: store }, children)));
    return render(ui, Object.assign({ wrapper: Wrapper }, options));
};
export function customRender(ui, options) {
    const { contextOptions, reduxOptions } = options;
    const allTheProviders = ({ children }) => {
        return (React.createElement(ReduxProvider, { reduxOptions: reduxOptions },
            React.createElement(ContextProviders, { contextOptions: contextOptions }, children)));
    };
    return render(ui, Object.assign({ wrapper: allTheProviders }, options));
}
const ContextProviders = ({ children, contextOptions, }) => {
    if (!contextOptions) {
        return React.createElement(React.Fragment, null, children);
    }
    let ContextWrapper;
    if (Array.isArray(contextOptions)) {
        ContextWrapper = contextOptions.reduceRight((acc, { context, value }) => {
            return React.createElement(context.Provider, { value: value }, acc);
        }, React.createElement(React.Fragment, null, children));
    }
    else {
        const { context, value } = contextOptions;
        ContextWrapper = (React.createElement(context.Provider, { value: value }, children));
    }
    return ContextWrapper;
};
const ReduxProvider = ({ children, reduxOptions, }) => {
    if (!reduxOptions) {
        return React.createElement(React.Fragment, null, children);
    }
    const { initialState, reducer = (state) => state } = reduxOptions;
    const store = createStore(reducer, initialState);
    return React.createElement(Provider, { store: store }, children);
};
//# sourceMappingURL=customRenders.js.map